export const errorMessagesMap: { [key: string]: string } = {
  'lead.firstName': "Petplan don't accept first names containing symbols, numbers, special characters or a blank entry, the size must be between 2 and 30.",
  'lead.name': "Petplan don't accept names containing symbols, numbers, special characters or a blank entry, the size must be between 2 and 30.",
  'lead.email': 'Please make sure email address is correct.',
  'lead.breedType': "Your pet's breed isn't insured by Petplan. <a href={/my-pet/{petid}/edit}>Click here to visit your pet profile to review your pet's breed.. </a>" ,
  'lead.street': 'Please make sure the street name is correct.',
  'lead.city': 'Please make sure the city name is correct.',
  'lead.county': 'Please make sure the county is correct.',
  'lead.postCode': 'Please make sure the post code is correct.',
  'pet.breedType': "You haven't listed a species for your pet or your pet's species isn't covered by Petplan.",
  'pet.name': "Petplan don't accept pet names containing symbols, numbers, special characters or a blank entry.",
  'address.line1': 'Please make sure the address is correct.',
};
